import { Axios } from '@src/app/context/Api/includes/Axios';
import { translateAssignments, translateCriteria } from '@src/entities/ActionPath/includes/functions';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isEmpty, isNil, isUndefined } from 'lodash';

/**
 * SaveActionPath
 *
 * Saves a single action path with the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const SaveActionPath = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': '/action-paths',
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    if (!isUndefined(thePayload?.id) && !isEmpty(thePayload?.id)) {
      requestArgs.method = 'PUT';
      requestArgs.headers['x-api-endpoint'] += `/${thePayload?.id}`;
    }

    requestArgs.data.name = thePayload?.name;
    requestArgs.data.actionPathScopeCode = thePayload?.remediation?.actionPathScopeCode;
    requestArgs.data.remediationMethod = thePayload?.remediation?.remediationMethod;
    requestArgs.data.note = thePayload?.remediation?.notes;
    requestArgs.data.manualAssociation = thePayload?.manualAssociation;
    requestArgs.data.exitCriteriaMethod = thePayload?.exitCriteriaMethod;
    requestArgs.data.status = thePayload?.status;
    requestArgs.data.initiativeType = thePayload?.remediation?.initiativeType;

    delete thePayload?.criteria?.entrance?.mergedStr;
    delete thePayload?.criteria?.exit?.mergedStr;

    if (!isNil(thePayload?.criteria)) {
      requestArgs.data.criteria = translateCriteria(thePayload?.criteria, 'outgoing');
    }

    if (!isNil(thePayload?.remediation?.assignments)) {
      requestArgs.data.assignments = translateAssignments(thePayload?.remediation?.assignments, 'outgoing');
    }

    const remoteResponse = await Axios.request(requestArgs);

    if (!isNil(remoteResponse?.data?.criteria)) {
      remoteResponse.data.criteria = translateCriteria(remoteResponse?.data?.criteria, 'incoming');
    }

    if (!isNil(remoteResponse?.data?.assignments)) {
      remoteResponse.data.assignments = translateAssignments(remoteResponse?.data?.assignments, 'incoming');
    }

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/ActionPath/api/requests/mutations/SaveActionPath.js -> SaveActionPath()', false, error);

    throw error;
  }
};
